import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { View, StyleSheet } from '@react-pdf/renderer'
import { Line } from './Line'
import { Status } from './Status'

import Text from './Text'
import SugestionLine from './SugestionLine'

import { statusByIcon } from '@util/recommendationUtil'
import { beautify } from '@util/recommendationBeautifier'

// Create styles
const styles = StyleSheet.create({
  title: {
    fontSize: 14,
    marginLeft: 8,
    fontFamily: 'Inter-Bold',
  },
  view: {},
  exclamationMark: {
    backgroundColor: '#E13A331A',
    borderRadius: 20,
    textAlign: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },
  line: {
    marginBottom: 16,
  },
})

// Create Document Component
export const ActionTitle = ({ titleColor, titleText, recommendations }) => (
  <>
    <View style={styles.container}>
      <Status text="!" textColor={titleColor} textStyle={{ fontSize: 12 }} />
      <View style={styles.view}>
        <Text style={[styles.title, { color: titleColor }]}>{titleText}</Text>
      </View>
    </View>
    <Line lineColor={titleColor} style={styles.line} />
    {_.map(recommendations, ({ label, icon }) => {
      const pretty = beautify(label)
      if (!pretty) return null

      return (
        <SugestionLine
          text={pretty}
          color={titleColor}
          status={statusByIcon[icon]}
          key={label}
        />
      )
    })}

  </>
)

ActionTitle.propTypes = {
  titleColor: PropTypes.string.isRequired,
  titleText: PropTypes.string.isRequired,
  recommendations: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      color: PropTypes.string,
      icon: PropTypes.func,
      label: PropTypes.string,
    })
  ).isRequired,
}
